import React from 'react';
import { Card, Statistic, Row, Col, Badge } from 'antd';
import {
  CheckCircleOutlined,
  EditOutlined,
  ToolOutlined,
  FileAddOutlined,
} from '@ant-design/icons';
import { WorkflowStatistics as WorkflowStatisticsType } from '../../types/primeArtifact';
import styles from './WorkflowStatistics.module.css';

interface WorkflowStatisticsProps {
  statistics: WorkflowStatisticsType;
  onStatusClick?: (status: string) => void;
}

const WORKFLOW_CONFIG = {
  IDENTIFIED: {
    title: 'Identified',
    icon: <FileAddOutlined />,
    color: '#d9d9d9',
    badgeStatus: 'default' as const,
  },
  DEFINED: {
    title: 'Defined',
    icon: <EditOutlined />,
    color: '#1890ff',
    badgeStatus: 'processing' as const,
  },
  DESIGNED: {
    title: 'Designed',
    icon: <EditOutlined />,
    color: '#722ed1',
    badgeStatus: 'processing' as const,
  },
  IMPLEMENTED: {
    title: 'Implemented',
    icon: <ToolOutlined />,
    color: '#faad14',
    badgeStatus: 'warning' as const,
  },
  VALIDATED: {
    title: 'Validated',
    icon: <CheckCircleOutlined />,
    color: '#52c41a',
    badgeStatus: 'success' as const,
  },
};

export const WorkflowStatistics: React.FC<WorkflowStatisticsProps> = ({
  statistics,
  onStatusClick,
}) => {
  const statusKeys: Array<keyof typeof WORKFLOW_CONFIG> = [
    'IDENTIFIED',
    'DEFINED',
    'DESIGNED',
    'IMPLEMENTED',
    'VALIDATED',
  ];

  return (
    <div className={styles.workflowStatistics}>
      <Row gutter={16} align="middle">
        <Col span={4}>
          <Statistic
            title="Total Artifacts"
            value={statistics.total_artifacts}
            valueStyle={{ fontSize: '20px', fontWeight: 'bold' }}
          />
        </Col>
        {statusKeys.map((status) => {
          const config = WORKFLOW_CONFIG[status];
          const count = statistics.by_status[status] || 0;
          return (
            <Col span={4} key={status}>
              <Card
                className={`status-card ${onStatusClick ? 'clickable' : ''}`}
                onClick={() => onStatusClick?.(status)}
                hoverable={!!onStatusClick}
                size="small"
                style={{ cursor: onStatusClick ? 'pointer' : 'default' }}
              >
                <div className="status-card-content">
                  <Badge
                    status={config.badgeStatus}
                    text={
                      <span style={{ color: config.color, fontWeight: 'bold' }}>
                        {config.title}
                      </span>
                    }
                  />
                  <div className="status-count" style={{ color: config.color }}>
                    {count}
                  </div>
                </div>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

